const prefix = '/community/api/plugin';
export const pluginApiUrlMap = {
  sendEmail: `${prefix}/mail`,
  getPlugins: `${prefix}/list`,
  getPluginDetail: `${prefix}/detail`,
  getUserReleasedPlugins: `${prefix}/user-released-plugins`,
  pluginInstall: `${prefix}/install`,
  getGuessLikePlugins: `${prefix}/guess-like`,
  getUserPluginInfo: `${prefix}/user-released-plugin-data`,
};
